import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=1320d156&"
import script from "./devices.vue?vue&type=script&lang=js&"
export * from "./devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "devices.vue"
export default component.exports